import React, { lazy, Suspense } from 'react'
import {
  ListNav,
  Featured
} from './index'
import { ListView } from './view-list'
import { Fallback, SidebarBasic } from '../../../components'
import { useSelector } from 'react-redux'

const StatisticView = lazy(() => import('./view-statistic'))

const MainContent = ({
  programs,
  fromOrganization,
  uniform,
  embed,
  defaultFeaturedItems,
  defaultItems,
  stateKey = 'programs'
}) => {
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)
  const [activeTab, setActiveTab] = React.useState(translation.VIEW.list[language.name])
  const query = useSelector(state => state.programs.query)

  return (
    <section className="container mx-auto hidden lg:block">
      <div className={`flex flex-wrap -mx-4 ${!embed && 'py-16'}`}>
        <aside className="w-3/12 px-4">
          <SidebarBasic query={query} />
        </aside>
        <main className="w-9/12 px-4">
          <ListNav
            fromOrganization={fromOrganization}
            onChange={setActiveTab}
            activeTab={activeTab}
          />
          {
            activeTab === translation.VIEW.list[language.name] &&
            <React.Fragment>
              {
                Object.keys(query).length === 0 &&
                <Featured embed={embed} defaultItems={defaultFeaturedItems}/>
              }
              <ListView uniform={uniform} defaultItems={defaultItems} stateKey={stateKey}/>
            </React.Fragment>
          }
          {
            activeTab === translation.VIEW.statistic[language.name] &&
            <Suspense fallback={<Fallback />}>
              <StatisticView />
            </Suspense>
          }
        </main>
      </div>
    </section>
  )
}

export { MainContent }
